// Этап 6, раздел 3 «Лицензии» (docs/PLAN.md) — карточка подписки в UserCardScreen.tsx +
// действия над станцией AV-Desk (выдать/отозвать/продлить). Вынесено в отдельный компонент —
// у каждой карточки своё локальное состояние загрузки/ошибки/поля "на сколько дней", держать это
// в UserCardScreen массивом по индексу было бы менее читаемо.
import { useState } from "react";

import {
  ApiError,
  issueLicense,
  renewLicense,
  revokeLicense,
  type Subscription,
} from "../api/client";

const SUBSCRIPTION_STATUS_LABEL: Record<string, string> = {
  active: "активна",
  expiring: "истекает",
  expired: "истекла",
  cancelled: "отменена",
};

function formatDate(iso: string): string {
  return new Date(iso).toLocaleString("ru-RU");
}

export function SubscriptionCard({
  subscription,
  onChanged,
}: {
  subscription: Subscription;
  onChanged: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [extraDays, setExtraDays] = useState("30");

  async function run(action: () => Promise<Subscription>) {
    setBusy(true);
    setError(null);
    try {
      await action();
      onChanged();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Не удалось выполнить действие");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card" style={{ marginBottom: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <strong>{subscription.plan.title}</strong>
        <span>{SUBSCRIPTION_STATUS_LABEL[subscription.status] ?? subscription.status}</span>
      </div>
      <div>
        {formatDate(subscription.started_at)} — {formatDate(subscription.expires_at)}
        {subscription.auto_renew ? "" : " (автопродление отключено)"}
      </div>
      <div>
        Устройств: {subscription.devices.length} из {subscription.device_limit}
        {subscription.bundle_partner &&
          ` · в паре с «${subscription.bundle_partner.plan.title}»`}
      </div>

      {error && <div className="error-text" style={{ marginTop: 8, marginBottom: 0 }}>{error}</div>}

      <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 12 }}>
        <button
          type="button"
          className="secondary"
          disabled={busy}
          onClick={() => run(() => issueLicense(subscription.id))}
        >
          Выдать станцию
        </button>
        <button
          type="button"
          className="secondary"
          disabled={busy}
          onClick={() => run(() => revokeLicense(subscription.id))}
        >
          Отозвать
        </button>
        <input
          type="number"
          min={1}
          max={366}
          value={extraDays}
          onChange={(e) => setExtraDays(e.target.value)}
          style={{ width: 64, padding: "8px 10px", border: "1px solid var(--border)", borderRadius: 6 }}
        />
        <button
          type="button"
          className="secondary"
          disabled={busy || !Number(extraDays)}
          onClick={() => run(() => renewLicense(subscription.id, Number(extraDays)))}
        >
          дней → продлить
        </button>
      </div>
    </div>
  );
}
